export const isSingleVariantOfferItemType = (item) => item.type === 'SINGLE_VARIANT_OFFER';
